import { apiRoutes } from "../Constant/ApiRoutes";
import {
  getRequest,
  putRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "../apiRequest";

// Helper to get the current KB ID for scoping API calls in multi-KB mode
const getKbParams = () => {
  const kbId = window.__kbId;
  return kbId ? { knowledgeBaseId: kbId } : undefined;
};

export const getUsersList = () => {
  return getRequest(apiRoutes.kbUsers, getKbParams());
};

export const changeUserRole = (userId, role) => {
  return patchRequest(
    apiRoutes.kbRoleUpdate.replaceAll("{{$userId}}", userId),
    { role },
    getKbParams()
  );
};

export const updateKbUsers = (payload) => {
  return putRequest(apiRoutes.kbUsers, payload, getKbParams());
};

const externalAccessUrl = (knowledgeBaseId) =>
  apiRoutes.kbExternalAccess.replaceAll("{{$kbId}}", knowledgeBaseId);

const externalAccessEntryUrl = (knowledgeBaseId, externalAccessId) =>
  apiRoutes.kbExternalAccessEntry
    .replaceAll("{{$kbId}}", knowledgeBaseId)
    .replaceAll("{{$entryId}}", externalAccessId);

export const getExternalAccess = (knowledgeBaseId) => {
  return getRequest(externalAccessUrl(knowledgeBaseId));
};

export const addExternalAccess = (knowledgeBaseId, entries) => {
  return postRequest(externalAccessUrl(knowledgeBaseId), { entries });
};

export const removeExternalAccess = (knowledgeBaseId, externalAccessId) => {
  return deleteRequest(
    externalAccessEntryUrl(knowledgeBaseId, externalAccessId)
  );
};
